export const JllBranding = {
	name: "jll", 
	colorHex: "#E30613", 
	logoUrl: "", 
	brandingKey: "jll"
};


// WEBPACK FOOTER //
// ./src/app/constants/Branding.ts